import React, { createContext, useContext } from 'react'
import { HorizontalTimelineState, Action } from './reducers/index'

export type HorizontalTimelineContextValue = {
  state: HorizontalTimelineState
  dispatch: React.Dispatch<Action>
}

const HorizontalTimelineContext = createContext<HorizontalTimelineContextValue | undefined>(undefined)
HorizontalTimelineContext.displayName = 'HorizontalTimelineContext'

export const useHorizontalTimelineContext = () => {
  const ctx = useContext(HorizontalTimelineContext)
  if (!ctx) throw new Error('useHorizontalTimelineContext must be used within <Provider>')
  return ctx
}

export default HorizontalTimelineContext
